export default [
  {
    path: '/consumerComplaint', name: 'consumerComplaint', component: () => import('@/pages/account/consumerComplaint'), meta: { title: '消费者投诉' },
  },
  {
    path: '/complaintsReply', name: 'complaintsReply', component: () => import('@/pages/account/complaintsReply'), meta: { title: '回复' },
  },
  {
    path: '/complaintHistory', name: 'complaintHistory', component: () => import('@/pages/account/complaintHistory'), meta: { title: '协商历史' },
  },
  {
    path: '/miniComplaintsReply', name: 'miniComplaintsReply', component: () => import('@/pages/account/miniComplaintsReply'), meta: { title: '回复' },
  },
  {
    path: '/miniComplaintHistory', name: 'miniComplaintHistory', component: () => import('@/pages/account/miniComplaintHistory'), meta: { title: '协商历史' },
  },
  {
    path: '/zfbMiniComplaintsHandle', name: 'zfbMiniComplaintsHandle', component: () => import('@/pages/account/zfbMiniComplaintsHandle'), meta: { title: '协商历史' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/notice.js